import styled from "styled-components";
import { mixins } from "@similarweb/styles";

export const Header = styled.h2`
    ${mixins.setFont({ $size: 16, $weight: 500 })};
    margin: 0 0 24px 0;
    line-height: 19px;
`;
